import React, {Component} from 'react';
import styles from "../templates/default.module.css";
import cx from 'classnames';
import MediaQuery from 'react-responsive';

class WideScreenContainer extends Component {
    render() {
        let className = '';

        if (this.props.className !== undefined) {
            className = this.props.className;
        }
        return (
            <div className={cx(className, "desktop")}>
                <MediaQuery minWidth={1440} className={cx(styles.desktop, 'desktop', "wide-screen")}>
                    {this.props.children}
                </MediaQuery>
            </div>
        );
    }
}

export default WideScreenContainer;